import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { ToastrService } from 'ngx-toastr';
import { SelectItem } from 'primeng/api';
import { Subscriber } from 'rxjs';
import { ConfirmModalComponent } from 'src/app/modals/confirm-modal/confirm-modal.component';
import { Page } from 'src/app/model/page';
import { ValidatorsManager } from 'src/app/model/ValidatorsManager';
import { UserService } from 'src/app/service/user-service.service';
import { endpoints } from 'src/endpoint/endpoints';
import { LogEventService } from '../pazienti/service/log-event.service';
import { PazientiService } from '../pazienti/service/pazienti.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-pannello-device',
  templateUrl: './pannello-device.component.html',
  styleUrls: ['./pannello-device.component.scss']
})
export class PannelloDeviceComponent implements OnInit {


  constructor(private http: HttpClient, private pazientiService: PazientiService, private fb: FormBuilder,
    private toastr: ToastrService, private route: ActivatedRoute, private userService: UserService,
    private logService: LogEventService, private modalService: BsModalService,) { }
  ColumnMode = ColumnMode;
  page = new Page();
  pageRef;
  count = 10;
  first = 0;
  loading: boolean;
  rows = [];
  currentId;
  validatorsManager: ValidatorsManager = new ValidatorsManager();
  status: SelectItem[];
  devicesForm;
  misurazioni;
  misurazioneString;
  confermaModalRef: BsModalRef;

  parametriQuery = {
    count: null,
    pageoffset: null
  };

  colonne = [
    { name: 'ID', prop: 'refId' },
    { name: 'ID device', prop: 'id' },
    { name: 'Mac device', prop: 'mac' },
    { name: 'Stato device', prop: 'status' },
  ];
  ngOnInit(): void {
    this.page.size = 10;
    this.rows = [];
    this.currentId = "";
    this.buildForm();
    this.status = [
      { value: '', label: 'Seleziona stato dispositivo', disabled: true },
      { value: 'active', label: 'Attivo' },
      { value: 'inactive', label: 'Disattivo' },
    ];
    this.misurazioni = [
      { label: "Frequenza cardiaca", code: "8867-4" },
      { label: "Ossigenazione", code: "59408-5" },
      { label: "Sistolica", code: "8480-6" },
      { label: "Diastolica", code: "8462-4" },
      { label: "Temperatura corporea", code: "8310-5" }
    ];

    this.parametriQuery.count = this.page.size;
    this.getAll();
  }

  buildForm() {
    this.validatorsManager.addValidatorByFormControlName('id', this.noWhiteSpaceValidator);
    this.validatorsManager.addValidatorByFormControlName('mac', this.noWhiteSpaceValidator);
    this.validatorsManager.addValidatorByFormControlName('manufacturer', this.noWhiteSpaceValidator);
    this.validatorsManager.addValidatorByFormControlName('model', this.noWhiteSpaceValidator);
    this.validatorsManager.addValidatorByFormControlName('version', this.noWhiteSpaceValidator);
    this.validatorsManager.addCampoObbligatorio('id');
    this.validatorsManager.addCampoObbligatorio('mac');
    this.validatorsManager.addCampoObbligatorio('status');
    this.validatorsManager.addCampoObbligatorio('manufacturer');
    this.validatorsManager.addCampoObbligatorio('model');
    this.validatorsManager.addCampoObbligatorio('version');
    this.validatorsManager.addCampoObbligatorio('misurazioni');
    this.devicesForm = this.fb.group({
      id: [''],
      mac: [''],
      status: [''],
      manufacturer: [''],
      model: [''],
      version: [''],
      misurazioni: [this.misurazioneString]
    });
    this.validatorsManager.form = this.devicesForm;
    this.validatorsManager.aggiungiValidatorObbligatori();
    this.validatorsManager.setAllValidatorsToForm();
  }

  getMisurazioniOnChange(misurazioni) {
    this.misurazioneString = '';
    for (let i = 0; i < misurazioni.value.length; i++) {
      this.misurazioneString += misurazioni.value[i].code + ';';
    }
  }
  setPage(pageInfo) {
    this.pageRef = pageInfo;
    this.first = this.pageRef.first;
    this.parametriQuery.pageoffset = pageInfo.first;
    this.page.pageNumber = pageInfo.first;
    this.getAll();
  }

  isRequired(formControlName: string): boolean {
    return this.validatorsManager.isRequired(formControlName);
  }

  public noWhiteSpaceValidator(control: FormControl) {
    const isWhiteSpace = (control.value || '').trim().length === 0;
    const isValid = !isWhiteSpace;
    return isValid ? null : { whitespace: null };
  }

  modCreazione() {
    this.currentId = "";
    this.devicesForm.reset();
  }

  save() {
    if (this.devicesForm.invalid) {
      this.devicesForm.markAllAsTouched();
      this.toastr.warning('Compilare i campi obbligatori');
      return;
    }
    let device = this.devicesForm.getRawValue();
    device.misurazioni = this.misurazioneString;
    if (this.currentId === "") {
      this.http.post(endpoints.saveDevice, device).toPromise()
        .then((resp: any) => {
          this.getAll();
          this.devicesForm.reset();
          this.toastr.success('Salvataggio avvenuto con successo.');
        }).catch(err => {
          if (err.status == 500) {
            this.toastr.error("Errore nel salvataggio del device,.");
            return;
          }
          else {
            this.toastr.error(err.error);
          }
        });
    } else {
      this.http.put(endpoints.updateDevice + this.currentId, device).toPromise()
        .then((resp: any) => {
          this.getAll();
          this.currentId = '';
          this.devicesForm.reset();
          this.toastr.success('Modifica avvenuta con successo.');
        }).catch(err => {
          if (err.status == 500) {
            this.toastr.error("Errore nel salvataggio del device,.");
            return;
          }
          else {
            this.toastr.error(err.error);
          }
        });
    }

  }


  getAll() {

    let path = endpoints.getDevices;
    for (let parametro in this.parametriQuery) {
      path += "/" + this.parametriQuery[parametro];
    }
    this.http.get(path).toPromise()
      .then((resp: any) => {
        this.page.totalElements = resp.total;
        this.page.totalPages = resp.total / 10;
        if (resp.entry == undefined) {
          resp.entry = new Array();
        }
        if (resp.entry) {
          this.rows = resp.entry.map(elem => ({
            refId: elem.resource.id,
            id: elem.resource.identifier.find(el => el.type.coding[0].code == "id_device").value,
            mac: elem.resource.identifier.find(el => el.type.coding[0].code == "mac").value,
            status: elem.resource.status
          })
          );
        } else {
          this.rows = null;
        }
      }).catch(err => {
        if (err.status == 400) {
          this.toastr.error("Errore nel recupero dei device.");
          return;
        }
        console.error(err);
        this.toastr.error("Errore nel recupero dei device.");
      });
  }
  getAllActive() {
    this.http.get(endpoints.getActiveDevices).toPromise()
      .then((resp: any) => {
      }).catch(err => {
        if (err.status == 400) {
          this.toastr.error("Errore nel recupero dei device.");
          return;
        }
        console.error(err);
        this.toastr.error("Errore nel recupero dei device.");
      });
  }

  getSingoloDevice(device) {
    if (device.refId == null) {
      this.toastr.error("Errore nel recupero dei device.");
      return;
    }
    this.currentId = device.refId;
    this.http.get(endpoints.getDeviceByIdentifier + this.currentId).toPromise()
      .then((resp: any) => {
        this.devicesForm.get("id").setValue(resp.identifier.find(el => el.type.coding[0].code == "id_device").value);
        this.devicesForm.get("mac").setValue(resp.identifier.find(el => el.type.coding[0].code == "mac").value);
        this.devicesForm.get("status").setValue(resp.status);
        this.devicesForm.get("manufacturer").setValue(resp.manufacturer);
        this.devicesForm.get("model").setValue(resp.model);
        this.devicesForm.get("version").setValue(resp.version);

        var support = resp.extension.find(el => el.url == "http://riatlas.it/extensions#device_measurements").valueString.split(";");
        var support2 = new Array;
        this.misurazioneString = '';
        for (let i = 0; i < support.length - 1; i++) {
          support2.push(this.misurazioni.find(el => el.code == support[i]));
          this.misurazioneString += support[i] + ';';
        }
        this.devicesForm.get("misurazioni").patchValue(support2);

      }).catch(err => {
        if (err.status == 400) {
          this.toastr.error("Errore nel recupero dei device.");
          return;
        }
        console.error(err);
        this.toastr.error("Errore nel recupero dei device.");
      });
  }
  deleteDevice(device) {
    if (device.refId == null) {
      this.toastr.error("Errore nel recupero dei device.");
      return;
    }
    this.http.delete(endpoints.deleteDevice + device.refId).toPromise()
      .then((resp: any) => {
        this.devicesForm.reset();
        this.getAll();
        this.currentId = "";
      }).catch(err => {
        if (err.status == 400) {
          this.toastr.error("Errore nel recupero dei device.");
          return;
        }
        console.error(err);
        this.toastr.error("Errore nel recupero dei device.");
      });
  }

  confirmDelete(device) {
    const initialState = { message: 'Eliminare il device? La procedura NON è reversibile.' };
    this.confermaModalRef = this.modalService.show(ConfirmModalComponent, { initialState });
    const newSubscriber = this.modalService.onHide.subscribe(r => {
      newSubscriber.unsubscribe();
      const res = this.confermaModalRef.content.result;
      if (res) {
        this.deleteDevice(device);
        this.toastr.success('Device eliminato con successo.');
      } else {
        this.toastr.info('Azione annullata.');
      }
    });
  }

}



